define [], () ->
  console.log "routes execd"
  name: 'home'
  public: true
  template: require('./home.jade')
  controller: require('./home.coffee')
  children: [
    name: 'landing', url: '^/',
    resolve: content: () -> null
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'login', url: '^/login/',
    template: require("./login/login.jade")
    controller: require("./login/login.coffee")
    params:
      view_app: null
  ,
    name: 'signup', url: '^/signup/{referrer_name}',
    params: 
      referrer_name: {value: null, squash: true}
    template: require("./signup/signup.jade")
    controller: require("./signup/signup.coffee")
  ,
    name: 'view_sample_application', url: '^/view/sample/'
    public: true
    controller: require("./sample/sample.coffee")
    template: require("./sample/sample.jade")
  ,
    name: 'password_reset', url: '^/accounts/password_reset/',
    template: require("./password_reset/password_reset.jade")
    controller: require("./password_reset/password_reset.coffee")
  ,
    name: 'password_reset_confirm', url: '^/accounts/reset/{uidb64}/{token}/',
    template: require("./password_reset_confirm/password_reset_confirm.jade")
    controller: require("./password_reset_confirm/password_reset_confirm.coffee")
  ,
    name: 'password_reset_done', url: '^/accounts/reset/done/',
    template: require("./password_reset_done/password_reset_done.jade")
    controller: require("./password_reset_done/password_reset_done.coffee")
  ,
    name: '403', template: require("./403/403.jade")
  ,
    name: '404', 
    template: require("./404/404.jade")
    controller: require("./404/404.coffee")
  ,
    name: '500', template: require("./500/500.jade")
  ,
    name: 'brokerage', url: '^/brokerage/',
    template: require("./brokerage/brokerage.jade")
    controller: require("./brokerage/brokerage.coffee")
    external_link: true
  ,
    name: 'security', url: '^/security/',
    template: require("./security/security.jade")
  ,
    name: 'applicant_warning_message', url: '^/applicant-warning-message/',
    template: require("./applicant_warning_message/applicant_warning_message.jade")
  ,
    name: 'applicant_ssn', url: '^/applicant-ssn/',
    template: require("./applicant_ssn/applicant_ssn.jade")
  ,
    name: 'how_to_get_verified_for_credit_reports', url: '^/how-to-get-verified-for-credit-reports',
    template: require("./how_to_get_verified_for_credit_reports/how_to_get_verified_for_credit_reports.jade")
  ,
  #   name: 'privacy', url: '^/privacy/',
  #   template: require("./privacy/privacy.jade")
  #   controller: require("./privacy/privacy.coffee")
  # ,
  #   name: 'terms_of_use', url: '^/termsofuse/',
  #   template: require("./terms_of_use/terms_of_use.jade")
  # ,
  #   name: 'terms_of_use_mp', url: '^/mypayments/termsofuse/',
  #   template: require("./terms_of_use/terms_of_use_mp.jade")
  # ,
    name: 'ambassador_terms', url: '^/terms/ambassador/',
    template: require("./terms_of_use/terms_of_use_ambassador.jade")
  ,
  #   name: 'support', url: '^/support/',
  #   template: require("./support/support.jade")
  # ,
    name: 'applicants', url: '^/applicants/',
    template: require("./applicants/applicants.jade")
  ,
    name: 'report_accuracy', url:'^/report-accuracy/',
    template: require("./about_reports/report_accuracy.jade")
  ,
    name: 'applicant_benefits', url: '^/applicant-benefits/',
    template: require("./applicant_benefits/applicant_benefits.jade")
  ,
    name: 'free_rental_application_pdf', url: '^/free-rental-application-pdf/',
    template: require("./keywords/free_rental_application_pdf.jade")

  # SEO Landing Pages
  ,
    name: 'tenant-background-check', url: '^/tenant-background-check/',
    resolve: content: () -> { main: "Run Background Checks On Your Tenants" }

    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'tenant-screening', url: '^/tenant-screening/',
    resolve:
      content: () ->
        {
          main: "Easy Online Tenant Screening"
          sub: "Instant, Automated Tenant Screening Services -- Get Started In 5 Minutes"
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'tenant-credit-check', url: '^/tenant-credit-check/',
    resolve:
      content: () ->
        {
          main: "Need Credit Reports For Tenants?"
          sub: "Rent Application Has You Covered"
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'online-rental-application', url: '^/online-rental-application/',
    resolve:
      content: () ->
        {
          main: "Online Rental Applications"
          sub: "Customizable. Mobile Friendly. Automatic Tenant Screening."
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'online-apartment-application', url: '^/online-apartment-application/',
    resolve:
      content: () ->
        {
          main: "Online Apartment Applications"
          sub: "Customizable. Mobile Friendly. Automatic Tenant Screening."
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'landlord-forms', url: '^/landlord-forms/',
    resolve:
      content: () ->
        {
          main: "Landlord Forms"
          sub: "Customize Your Own Rental Application Form For Screening Tenants"
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'landlord-tenant-forms', url: '^/landlord-tenant-forms/',
    resolve:
      content: () ->
        {
          main: "Landlord Tenant Forms"
          sub: "Need A Rental Application Form For Screening Tenants? Use Our Template Or Customize Your Own"
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'forms-for-landlords', url: '^/forms-for-landlords/',
    resolve:
      content: () ->
        {
          main: "Forms For Landlords"
          sub: "Looking For A Rental Application Form For Screening Tenants? Use Our Proven Template Or Customize Your Own."
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'alt', url: '^/alt/',
    resolve: content: () ->
        {
          main: "Landlords, Screen Your Tenants. Fast."
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/alt/landing.jade")
  ,
    name: 'condo.com', url: '^/condo.com/',
    resolve: content: () -> null
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ,
    name: 'fill-your-vacancies', url: '^/fill-your-vacancies/',
    resolve:
      content: () ->
        {
          main: "Fill Your Vacancies Faster With Perfect Tenants"
          sub: "Build Your Own Customized Online Rental Application Form -- Get Started In 5 Minutes"
        }
    controller: require("./landing/landing.coffee")
    template:   require("./landing/landing.jade")
  ]



// WEBPACK FOOTER //
// ./components/home/routes.coffee